module.exports = __webpack_public_path__ + "static/media/best-burger-ever-burger-desktop-fr.7c2f09ed.jpg";